(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bloom-gift-builder"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('bloom-gift-builder'))customElements.define('bloom-gift-builder',class extends HTMLElement{
  connectedCallback(){
    if(this.ready)return;this.ready=true;
    const q=s=>this.querySelector(s),radios=[...this.querySelectorAll('input[name="id"]')],amount=q('[data-amount-input]'),form=q('form'),fields=q('[data-recipient-fields]'),name=q('[data-recipient-name]'),message=q('[data-message]');
    const originalName=q('[data-preview-name]').textContent,originalMessage=q('[data-preview-message]').textContent;
    const preview=()=>{q('[data-preview-name]').textContent=fields.hidden?originalName:name.value.trim()||originalName;q('[data-preview-message]').textContent=fields.hidden?originalMessage:message.value||originalMessage;q('[data-count]').textContent=String(message.value.length);};
    const selected=()=>{const radio=radios.find(r=>r.checked);if(!radio)return;amount.value=radio.dataset.value;amount.setCustomValidity('');q('[data-preview-value]').textContent=radio.nextElementSibling.textContent;q('[data-total]').textContent=radio.dataset.price;};
    radios.forEach(r=>r.addEventListener('change',selected));
    amount.addEventListener('input',()=>{const value=amount.value.trim(),match=radios.find(r=>!r.disabled&&r.dataset.value===value);amount.setCustomValidity(match?'':q('[data-amount-error]').textContent);if(match){match.checked=true;selected();}});
    this.querySelectorAll('input[name="bloom_delivery"]').forEach(r=>r.addEventListener('change',()=>{const self=r.value==='self';fields.hidden=self;fields.querySelectorAll('input,textarea').forEach(el=>el.disabled=self);q('[data-self-note]').hidden=!self;preview();}));
    name.addEventListener('input',preview);message.addEventListener('input',preview);
    form.addEventListener('submit',event=>{if(this.dataset.native!=='true'||!form.reportValidity()){event.preventDefault();return;}const submit=q('[type="submit"]');submit.disabled=true;});
    selected();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bloom-gift-card-studio"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bloom-gift-card-studio')) {
    customElements.define('bloom-gift-card-studio', class extends HTMLElement {});
  }

  document.querySelectorAll('[data-bloom-gift]').forEach((root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const form = root.querySelector('[data-gift-form]');
    const amountInput = root.querySelector('[data-amount-input]');
    const amountRange = root.querySelector('[data-amount-range]');
    const variantInput = root.querySelector('[data-variant-id]');
    const variantMapSelect = root.querySelector('[data-variant-map]');
    const amountError = root.querySelector('[data-amount-error]');
    const submit = root.querySelector('[data-submit]');
    const recipientFields = root.querySelector('[data-recipient-fields]');
    const recipientEmail = root.querySelector('[data-recipient-email]');
    const sendRecipient = root.querySelector('[data-send-recipient]');
    const selfNote = root.querySelector('[data-self-note]');
    const messageInput = root.querySelector('[data-message]');
    const sendOn = root.querySelector('[data-send-on]');
    const offset = root.querySelector('[data-timezone-offset]');
    let byAmount = new Map([...variantMapSelect.options].map((option) => [Number(option.dataset.amount), option]));
    let variantsReady = false;

    const setAmount = (raw) => {
      const amount = Math.max(100, Math.min(1000, Math.round(Number(raw) || 100)));
      amountInput.value = String(amount);
      amountRange.value = String(amount);
      root.querySelector('[data-total-amount]').textContent = amount.toLocaleString('he-IL');
      root.querySelectorAll('[data-quick-amount]').forEach((button) => button.classList.toggle('is-selected', Number(button.dataset.quickAmount) === amount));
      const option = byAmount.get(amount);
      const valid = Boolean(option && option.dataset.available === 'true');
      amountError.hidden = !variantsReady || valid;
      amountInput.setCustomValidity(!variantsReady || valid ? '' : 'הסכום הזה אינו זמין כרגע');
      if (variantInput && option) variantInput.value = option.value;
      if (submit) submit.disabled = !variantsReady || !valid;
      return variantsReady && valid;
    };

    const loadAllVariants = async () => {
      try {
        for (let page = 1; page <= 8; page += 1) {
          const response = await fetch(`${root.dataset.productUrl}.js?page=${page}`, { headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('variant_load_failed');
          const data = await response.json();
          const variants = Array.isArray(data.variants) ? data.variants : [];

          variants.forEach((variant) => {
            const amount = Math.round(Number(variant.price) / 100);
            if (!amount || byAmount.has(amount)) return;
            const option = document.createElement('option');
            option.value = String(variant.id);
            option.dataset.amount = String(amount);
            option.dataset.available = String(variant.available !== false);
            option.textContent = `${amount} ₪`;
            variantMapSelect.appendChild(option);
          });

          byAmount = new Map([...variantMapSelect.options].map((option) => [Number(option.dataset.amount), option]));
          if (variants.length < 250) break;
        }
      } catch (error) {
        console.warn('Bloom gift card variants could not be fully loaded.', error);
      } finally {
        variantsReady = true;
        setAmount(amountInput.value);
      }
    };

    amountRange.addEventListener('input', () => setAmount(amountRange.value));
    amountInput.addEventListener('input', () => setAmount(amountInput.value));
    amountInput.addEventListener('blur', () => setAmount(amountInput.value));
    root.querySelectorAll('[data-quick-amount]').forEach((button) => button.addEventListener('click', () => setAmount(button.dataset.quickAmount)));

    root.querySelectorAll('input[name="bloom_delivery_mode"]').forEach((radio) => radio.addEventListener('change', () => {
      const self = radio.checked && radio.value === 'self';
      recipientFields.hidden = self;
      selfNote.hidden = !self;
      recipientFields.querySelectorAll('input,textarea').forEach((field) => {
        if (field !== sendRecipient && field !== offset) field.disabled = self;
      });
      sendRecipient.disabled = self;
      offset.disabled = self;
      recipientEmail.required = !self;
    }));

    messageInput.addEventListener('input', () => {
      root.querySelector('[data-message-count]').textContent = String(messageInput.value.length);
    });

    const now = new Date();
    const max = new Date(now); max.setDate(max.getDate() + 90);
    sendOn.min = now.toISOString().slice(0, 10);
    sendOn.max = max.toISOString().slice(0, 10);
    offset.value = String(now.getTimezoneOffset());

    if (form) form.addEventListener('submit', async (event) => {
      if (root.dataset.isGiftCard !== 'true' || !setAmount(amountInput.value) || !form.reportValidity()) {
        event.preventDefault();
        return;
      }
      event.preventDefault();
      submit.disabled = true;
      submit.textContent = 'עוברים לתשלום…';
      try {
        const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (!response.ok) throw new Error('cart_add_failed');
        window.location.assign('/checkout');
      } catch (error) {
        submit.disabled = false;
        submit.textContent = 'להמשך לתשלום';
        amountError.textContent = 'לא הצלחנו להמשיך לתשלום. נסי שוב בעוד רגע.';
        amountError.hidden = false;
      }
    });

    setAmount(amountInput.value);
    loadAllVariants();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
